import React from "react";
import "./previous-buys-section.scss";
import ProductListSliderTheme2 from "../ProductListSliderTheme2";
import { useGetRecentlyPurchaseProducts } from 'hooks/useGetRecentlyPurchaseProducts';

const PreviousBuysSection = () => {
  const { data: previousBuysProductList } = useGetRecentlyPurchaseProducts("home", "0");

  if (previousBuysProductList?.length) {
    return null
  }

  return (
    <div className="previous-buys-section-wrapper">
      <div className="container">
        <div className="previous-buys-section-alignment">
          <h2>Your previous buys</h2>
          <p>Products you've enjoyed</p>
        </div>
      </div>
      <ProductListSliderTheme2  products={previousBuysProductList} />
    </div>
  );
};
export default PreviousBuysSection;
